import { useState, useEffect, useRef } from 'react';

export function ShowUpImg(props) {
  const [isInScreen, setIsInScreen] = useState<boolean>(false);
  const ref = useRef<HTMLHeadingElement>(null)

  const onScroll = (): void => {
    if (ref.current!.getBoundingClientRect().top <= window.innerHeight){
      setIsInScreen(true)
    } else {
      setIsInScreen(false)
    }
  };

  useEffect(() => {
    const target = props.scrollRef ? props.scrollRef.current : document;
    if (ref.current) target.addEventListener("scroll", onScroll);
    return (): void => target.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <img
      src={props.src}
      ref={ref}
      className = {`showUpImg ${isInScreen ? "shown" : ""}`}
      onClick={() => {
        props.setIsModalShown(true)
      }}
    />
  )
}